export default __webpack_public_path__ + "static/cafe_36023-abffb23749da663278cd300eb22e436f.png";